import { SitecoreIds } from 'lib/constants';
import { RuleContext } from '../../rules';
import { WhenCondition } from '../../conditions';
import { RuleConditionData } from '../../serialization';
import { ConditionRule } from 'lib/reviews/types';
import { RulesConstants } from 'lib/constants/rules';

export const SpecificAffiliateConditionId =
  SitecoreIds.Settings.Rules.Definitions.Elements.RbA_Reviews.SpecificAffiliate.ItemId;

export class SpecificAffiliateCondition<T extends RuleContext> extends WhenCondition<T> {
  affiliateItemId: string;
  constructor(condition: RuleConditionData) {
    super();
    this.affiliateItemId = condition.affiliateItemId as string;
  }

  execute(ruleContext: T): boolean {
    const conditions: Array<ConditionRule> =
      (ruleContext.parameters[RulesConstants.Parameters.Conditions] as Array<ConditionRule>) ?? [];
    conditions.push({
      propertyName: 'affiliateId',
      comparison: 'equals',
      value: Number(this.affiliateItemId),
    });
    ruleContext.parameters[RulesConstants.Parameters.Conditions] = conditions;
    return ruleContext.parameters[RulesConstants.Parameters.Operator] ==
      RulesConstants.Operators.And
      ? true
      : false;
  }
}
